.flag {
    display: block;
    object-fit: cover;
}
